import { Card, Flex } from 'antd';
import classNames from 'classnames';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { css } from 'config/emotionCss';

import { Title, Button } from 'ui/base';

import FleetbackIcon from 'ui/base/icons/fleetback-icon.svg';
import FleetbackLabel from 'ui/base/icons/fleetback-label.svg';

const cardStyle = css`
  .ant-card-head {
    background-color: #003763;
    padding: 16px;
  }
`;

const ErrorRefreshPage = () => {
  const cardHeader = (
    <>
      <FleetbackIcon style={{ width: '78px', height: '66px', color: 'white' }} />
      <FleetbackLabel width="170" style={{ color: 'white', marginLeft: '20px' }} />
    </>
  );

  const handleRefresh = () => {
    window.location.reload(true);
  };

  return (
    <Flex justify="center" align="center" className="h-100">
      <Card className={classNames('w-50', cardStyle)} title={cardHeader} bordered data-cy="front-error">
        <Flex justify="space-between" align="center" className="ml-5">
          <Flex vertical>
            <Title level={2}>
              <FormattedMessage id="page.error.frontError.title" defaultMessage="Oops!" />
            </Title>
            <FormattedMessage
              id="page.error.frontError.description"
              defaultMessage="Something's gone wrong...{linebreak}Please click refresh button to reload the page"
              values={{ linebreak: <br /> }}
            />
          </Flex>
          <Button type="primary" onClick={handleRefresh} className="mr-7">
            <FormattedMessage id="refresh" defaultMessage="Refresh" />
          </Button>
        </Flex>
      </Card>
    </Flex>
  );
};

export default ErrorRefreshPage;
